<template>
  <div>
    <table class="table table-sm mb-8">
      <tbody>
        <tr>
          <th width="30%">{{ trans('Name') }}</th>
          <td>{{ `${registration.firstname} ${registration.lastname}` }}</td>
        </tr>
        <tr>
          <th>{{ trans('E-mail') }}</th>
          <td>{{ registration.email }}</td>
        </tr>
        <tr>
          <th>{{ trans('Employer') }}</th>
          <td>{{ employer.name }}</td>
        </tr>
      </tbody>
    </table>

    <MdlSwitch v-model:checked="registration.accepted">
      <span v-html="acceptLabel"></span>
    </MdlSwitch>
    <div class="mt-2"></div>
    <MdlSwitch v-model:checked="registration.newsletter" :data-qa-id="pendo('receiveNewsletter')">
      {{ trans('Yes, I want to receive newsletters') }}
    </MdlSwitch>

    <Captcha class="mt-8" v-model="captcha" />
  </div>
</template>

<script>
import { trans } from '@/munio/i18n'
import { pendoLabel } from '@/munio/utils'
import MdlSwitch from '@component/mdl/Switch.vue'
import Captcha from '@component/Captcha.vue'

export default {
  inject: ['registration'],

  components: {
    Captcha,
    MdlSwitch,
  },

  data() {
    return {
      accepted: false,
    }
  },

  computed: {
    acceptLabel() {
      return trans('I accept the <a href=":link">terms & conditions</a>', {
        link: `/${Munio.config.i18n.key}/terms`,
      })
    },
    employer() {
      return this.$store.state.employer || this.registration.company
    },
    captcha: {
      get() {
        return this.$store.state.captcha
      },
      set(value) {
        this.$store.commit('captcha', value)
      },
    },
  },

  methods: {
    trans,
    pendo: pendoLabel,
    validate() {
      return true
    },
  },
}
</script>
